/**
 * 404 Not Found page
 */
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/Button';

export default function NotFound() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-6">
      <div className="text-center">
        <div className="mb-8">
          <span className="text-9xl">🔍</span>
        </div>
        <h1 className="text-6xl font-bold text-gray-900 mb-4">404</h1>
        <h2 className="text-2xl font-semibold text-gray-700 mb-4">{t('errors.pageNotFound')}</h2>
        <p className="text-gray-600 mb-8 max-w-md mx-auto">
          {t('errors.pageNotFoundDescription')}
        </p>
        <div className="flex gap-4 justify-center">
          <Link to="/dashboard">
            <Button>{t('common.goToDashboard')}</Button>
          </Link>
          <Link to="/">
            <Button variant="ghost">{t('common.goToHome')}</Button>
          </Link>
        </div>
      </div>
    </div>
  );
}
